module.exports = ReactBootstrap;


//////////////////
// WEBPACK FOOTER
// external "ReactBootstrap"
// module id = 10
// module chunks = 0